import { createSelector } from 'reselect';
import { get, subtract } from 'lodash/fp';

import salaryExpenditureSelector from './salaryExpenditureSelector';

const salaryRemainingSelector = createSelector(
  get('challenge.salaryCap'),
  salaryExpenditureSelector,
  subtract
);

export default salaryRemainingSelector;
